document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('[role="tab"]');
  const panels = document.querySelectorAll('[role="tabpanel"]');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      // reset tabs
      tabs.forEach(t => t.setAttribute('aria-selected', 'false'));
      panels.forEach(p => p.classList.add('tw:hidden'));

      // activate current
      tab.setAttribute('aria-selected', 'true');
      const target = document.querySelector(tab.dataset.hsTab);
      if (target) target.classList.remove('tw:hidden');
    });
  });
});